import React from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import {
  Item,
  ItemTitle,
  ItemDetails,
  Details,
  StatusCollor,
  Status,
  ImgDetails,
  ItemStatusResponsive,
  ItemDesktop,
  DivisionItems,
  ItemDetailsRight,
  ItemRight,
  ContentTitle,
  ContentStatus
} from "./styles";

import information from "~/assets/images/information.svg";

export default function ItemList({
  order,
  activeModal,
  ordersInView,
  setOpenModal,
  setCanisterChoosed
  }) {
  const history = useHistory();
  const dispatch = useDispatch();
  const orderEditReducer = useSelector((state) => state.orderEditReducer);
  const orderReducer = useSelector((state) => state.orderReducer);

  // const [hasEdit, setHasedit] = useState(false);
  // const [hasEditHour, setHaseditHour] = useState(false);
  // const [openModal, setOpenModal] = useState(false);

  // useEffect(() => {
  //   let todayDate = moment().format("DD/MM/YYYY")
  //   let todayMouth = moment().format("MM")
  //   let hourNow = moment().format("HH:mm")
  //   let continueCount = todayDate < moment(order.cutDate).format("DD/MM/YYYY")
  //   let continueCountMounth = moment(order.cutDate).format("MM") >= todayMouth
  //   if(continueCount && continueCountMounth) {
  //     if(todayDate < moment(order.cutDate).format("DD/MM/YYYY")) {
  //       if(todayDate === moment(order.cutDate).format("DD/MM/YYYY")) {
  //         if(hourNow > moment(order.cutDate, "HH:mm:ss").format("HH:mm")) {
  //           setHaseditHour(false)
  //         } else {
  //           setHaseditHour(true)
  //         }
  //       } else {
  //         setHaseditHour(true)
  //       }
  //     } else {
  //       setHaseditHour(false)
  //     }
  //   } else {
  //     setHaseditHour(false)
  //   }
  // }, []);

  const StatusText = ({ status }) => {
    if (
      status === "PENDING_ANALYSIS"
    ) {
      return <span>AGUARDANDO ANÁLISE</span>
    } else if(status === "APPROVED") {
      return <span>APROVADO</span>
    } else if(status === "PENDING_APPROVAL") {
      return <span>AGUARDANDO APROVAÇÃO</span>;
    } else {
      return <span>REPROVADO</span>;
    }
  };

  async function handleClick(id) {

  }

  return (
    // <>
    //   {openModal ? (
    //     <ModalDashboard
    //       carnister={order}
    //       close={() => setOpenModal(!openModal)}
    //     />
    //   ) : (
        <DivisionItems>
          <Item>
            <>
              <ContentTitle>
                <ItemTitle fontSize={"1rem"}>N° do lacre {order.sealNumber}</ItemTitle>
                {/* <ItemTitle weight={"400"} fontSize={".7rem"}>
                  {moment(order.analysisDate, "YYYY-MM-DD").format("DD/MM/YYYY")}
                </ItemTitle> */}
              </ContentTitle>
              <ItemStatusResponsive>
                <ItemDetails>
                  <Status>Status: </Status>
                  <ContentStatus>
                    <StatusCollor status={order.status}></StatusCollor>
                    <StatusText status={order.status} />
                  </ContentStatus>
                </ItemDetails>
                <ItemDetails
                  onClick={() => {
                    setCanisterChoosed(order)
                    setOpenModal(true)
                  }}
                  margin={'.3rem 0 0 0'}
                  margin500={'.5rem -.1rem 0 0'}
                  style={ItemDetailsRight}
                >
                  <Details>
                    Detalhes
                    <ImgDetails src={information} alt="Ícone de informações" />
                  </Details>
                </ItemDetails>
                <div />
              </ItemStatusResponsive>
            </>
          </Item>
          <ItemDesktop>
            <ContentTitle>
              <ItemTitle fontSize={"1rem"}>N° do lacre {order.sealNumber}</ItemTitle>
              <ItemRight>
                <ItemDetails>
                  <Status>Status: </Status>
                  <ContentStatus>
                    <StatusCollor status={order.status}></StatusCollor>
                    <StatusText status={order.status} />
                  </ContentStatus>
                </ItemDetails>
                {/* <div style={{
                  display: "grid",
                  gridTemplateColumns: "2fr 1fr"
                }}>
                  <ItemTitle weight={"400"} fontSize={".7rem"} style={{ flexDirection: 'column' }}>
                    <p style={{ color: '#707070' }}>Data: </p>
                    {moment(order.sealNumber, "YYYY-MM-DD").format("DD/MM/YYYY")}
                  </ItemTitle>
                </div> */}
              </ItemRight>
              <Details onClick={() => {
                setCanisterChoosed(order)
                setOpenModal(true)
              }}>
                Detalhes
                <ImgDetails src={information} alt="Ícone de informações" />
              </Details>
            </ContentTitle>
          </ItemDesktop>
        </DivisionItems>
    //   )}
    // </>
  );
}
